import { useMutation } from '@tanstack/react-query';
import { regenerateInvoice } from '../Services/InvoiceService';

const usePostRegenerateInvoice = (options = {}) => useMutation(regenerateInvoice, options);

export default usePostRegenerateInvoice;
